import React, { useEffect, useState } from 'react';
import { ModalHeader, ModalBody, ModalFooter, Button, Input, Label } from 'reactstrap';
import Rodal from '../Rodal/Rodal';
import './RejectionReasonReviewDialog.scss';

interface RejectionReasonReviewDialogProps {
    isVisible: boolean;
    initialReason: string;
    onCancel: () => void;
    onRelease: (leaveComment: string) => void;
}

const RejectionReasonReviewDialog = ({
    isVisible,
    initialReason,
    onCancel,
    onRelease,
}: RejectionReasonReviewDialogProps) => {
    const [reason, setReason] = useState(initialReason);

    useEffect(() => {
        if (isVisible) {
            setReason(initialReason);
        }
    }, [isVisible, initialReason]);

    if (!isVisible) {
        return null;
    }

    return (
        <Rodal
            visible={true}
            animation="slideTop"
            width={498}
            showCloseButton={false}
            onClose={onCancel}
            className="confirmation-modal rejection-reason-review-dialog">
            <ModalHeader>Review Rejection Reason</ModalHeader>
            <ModalBody>
                <Label className="label-textarea">
                    The buyer left this feedback. Review or edit it before
                    posting it to the seller.
                </Label>
                <Input
                    autoFocus
                    type="textarea"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                />
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    className="btn-cancel"
                    onClick={onCancel}>
                    Cancel
                </Button>
                <Button
                    type="button"
                    style={{ height: 'auto' }}
                    className="btn btn-primary"
                    disabled={!reason.trim()}
                    onClick={() => onRelease(reason.trim())}>
                    Post to Seller
                </Button>
            </ModalFooter>
        </Rodal>
    );
};

export default RejectionReasonReviewDialog;
